import { jsx as _jsx } from "react/jsx-runtime";
import React, { createContext, useContext, useMemo } from 'react';
const INIT_STATE = {
    excludePaymentTooltipPrefix: false,
};
const InventoryTrimCardContext = createContext(INIT_STATE);
export const useInventoryTrimCardContext = () => useContext(InventoryTrimCardContext);
const InventoryTrimCardProvider = ({ children, ...fields }) => {
    const value = useMemo(() => fields, [fields]);
    return _jsx(InventoryTrimCardContext.Provider, { value: value, children: children });
};
export default InventoryTrimCardProvider;
